/**
 * @generated SignedSource<<e88ea47390807f76f38cf3b9e90a2434>>
 * @relayHash 8413120c5044e28e77415d3555a15759
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9e4e25d9fc4d23494ef793218f910b44fe2c294adda73d3b1886bc6021f1a691

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GlobalPermissionsPageQuery$variables = {
  cloudId: string;
};
export type GlobalPermissionsPageQuery$data = {
  readonly jira: {
    readonly globalPermissionsAndGrants: {
      readonly globalPermissionGrants?: ReadonlyArray<{
        readonly groups: ReadonlyArray<{
          readonly groupId: string;
          readonly name: string;
        } | null | undefined>;
        readonly isManagedByJira: boolean;
        readonly permission: {
          readonly description: string;
          readonly key: string;
          readonly name: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"RemovePermissionModal">;
      } | null | undefined>;
      readonly " $fragmentSpreads": FragmentRefs<"GrantPermissionModal">;
    };
  };
};
export type GlobalPermissionsPageQuery = {
  response: GlobalPermissionsPageQuery$data;
  variables: GlobalPermissionsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "key"
},
v4 = {
  "kind": "ScalarField",
  "name": "description"
},
v5 = {
  "kind": "ScalarField",
  "name": "groupId"
},
v6 = {
  "kind": "ScalarField",
  "name": "isManagedByJira"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GlobalPermissionsPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "alias": "globalPermissionsAndGrants",
                "args": (v1/*: any*/),
                "kind": "LinkedField",
                "name": "getGlobalPermissionsAndGrants",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "GrantPermissionModal"
                      },
                      {
                        "kind": "RequiredField",
                        "field": {
                          "concreteType": "JiraGlobalPermissionGrants",
                          "kind": "LinkedField",
                          "name": "globalPermissionGrants",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "FragmentSpread",
                              "name": "RemovePermissionModal"
                            },
                            {
                              "kind": "RequiredField",
                              "field": {
                                "concreteType": "JiraGlobalPermission",
                                "kind": "LinkedField",
                                "name": "permission",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "RequiredField",
                                    "field": (v2/*: any*/),
                                    "action": "THROW",
                                    "path": "jira.globalPermissionsAndGrants.globalPermissionGrants.permission.name"
                                  },
                                  {
                                    "kind": "RequiredField",
                                    "field": (v3/*: any*/),
                                    "action": "THROW",
                                    "path": "jira.globalPermissionsAndGrants.globalPermissionGrants.permission.key"
                                  },
                                  {
                                    "kind": "RequiredField",
                                    "field": (v4/*: any*/),
                                    "action": "THROW",
                                    "path": "jira.globalPermissionsAndGrants.globalPermissionGrants.permission.description"
                                  }
                                ]
                              },
                              "action": "THROW",
                              "path": "jira.globalPermissionsAndGrants.globalPermissionGrants.permission"
                            },
                            {
                              "kind": "RequiredField",
                              "field": {
                                "concreteType": "JiraGroup",
                                "kind": "LinkedField",
                                "name": "groups",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "RequiredField",
                                    "field": (v2/*: any*/),
                                    "action": "THROW",
                                    "path": "jira.globalPermissionsAndGrants.globalPermissionGrants.groups.name"
                                  },
                                  {
                                    "kind": "RequiredField",
                                    "field": (v5/*: any*/),
                                    "action": "THROW",
                                    "path": "jira.globalPermissionsAndGrants.globalPermissionGrants.groups.groupId"
                                  }
                                ]
                              },
                              "action": "THROW",
                              "path": "jira.globalPermissionsAndGrants.globalPermissionGrants.groups"
                            },
                            {
                              "kind": "RequiredField",
                              "field": (v6/*: any*/),
                              "action": "THROW",
                              "path": "jira.globalPermissionsAndGrants.globalPermissionGrants.isManagedByJira"
                            }
                          ]
                        },
                        "action": "THROW",
                        "path": "jira.globalPermissionsAndGrants.globalPermissionGrants"
                      }
                    ],
                    "type": "JiraGlobalPermissionGrantsList"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.globalPermissionsAndGrants"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GlobalPermissionsPageQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "globalPermissionsAndGrants",
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "getGlobalPermissionsAndGrants",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "JiraGlobalPermissionGrants",
                    "kind": "LinkedField",
                    "name": "globalPermissionGrants",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraGlobalPermission",
                        "kind": "LinkedField",
                        "name": "permission",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v2/*: any*/),
                          (v4/*: any*/)
                        ]
                      },
                      (v6/*: any*/),
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__id"
                          }
                        ]
                      },
                      {
                        "concreteType": "JiraGroup",
                        "kind": "LinkedField",
                        "name": "groups",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v5/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "JiraGlobalPermissionGrantsList"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "9e4e25d9fc4d23494ef793218f910b44fe2c294adda73d3b1886bc6021f1a691",
    "metadata": {},
    "name": "GlobalPermissionsPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7bca3e2acdc052f43259a837930737af";

export default node;
